









import {Component, Vue} from "vue-property-decorator";
import AppDialogContainer from "@/components/AppDialogContainer.vue";
import {RouterStore} from "@/interfaces/store-interfaces/router-store.interface";
import {bus} from "@/plugins/bus";
import {EventEmitter} from "@/interfaces/store-interfaces/event-emitter.interface";

@Component({
  components: {
    AppDialogContainer,
  }
})
export default class App extends Vue {
  isInit = false;
  iosFullscreen = false;
  scrollY: number = 0;

  get withLayout(): boolean {
    let hideOnRoutes = [
      RouterStore.ROUTE_NAME.RHIZOME_PAGE,
    ];
    return !hideOnRoutes.includes(this.$store.state.route.name);
  }

  created() {
    bus.$on(EventEmitter.Events.IOS_FULLSCREEN_CHANGE, this.iosFullscreenChange);
    let externalScript = document.createElement('script');
    externalScript.setAttribute('src', 'https://consent.cookiebot.com/uc.js?cbid=7a28f306-de40-49d6-97b4-0c68738db3d9');
    document.head.appendChild(externalScript);
  }

  async mounted() {
    const response: any = await this.$store.dispatch('contentPage/getEndpoints');
    this.isInit = true;
    window.addEventListener('resize', this.calcVh);
    this.calcVh();
    this.setUpCookieBot();
  }

  async setUpCookieBot() {
    localStorage.setItem('acceptVimeoCookies', 'true');
    window.addEventListener('CookiebotOnAccept', function (e) {
      CookiebotCallback_OnAccept();
    }, false);

    window.addEventListener('CookiebotOnDecline', function (e) {
      CookiebotCallback_OnDecline();
    }, false);

    function CookiebotCallback_OnAccept() {
      // localStorage.setItem('acceptVimeoCookies', 'true');
      // bus.$emit('UpdateCookieBotState');

      if ((window as any).Cookiebot.consent.statistics) {
        (function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
          (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*(+new Date());a=s.createElement(o),
          m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
        })(window,document,'script','//www.google-analytics.com/analytics.js','ga');

        (window as any).ga('create',  process.env.VUE_APP_GOOGLE_ANALYTICS, 'auto');
        (window as any).ga('send', 'pageview');

        // Insert gtg
        if (process.env.VUE_APP_GTG_ID) {
          let externalScript = document.createElement('script');
          externalScript.setAttribute('src', `https://www.googletagmanager.com/gtag/js?id=${process.env.VUE_APP_GTG_ID}`);
          document.head.appendChild(externalScript);

          let graAccess = false;
          let intervalId = setInterval(() => {
            if (!graAccess) {
              try {
                (window as any).dataLayer = (window as any).dataLayer || [];
                //@ts-ignore
                function gtag() {dataLayer.push(arguments);}
                //@ts-ignore
                gtag('js', new Date());
                //@ts-ignore
                gtag('config', process.env.VUE_APP_GTG_ID);
                graAccess = true;
                clearInterval(intervalId);
              }
              catch (e) {}
            }
          }, 100);
        }
      }
    }

    function CookiebotCallback_OnDecline() {
      // localStorage.setItem('acceptVimeoCookies', 'false');
      bus.$emit('UpdateCookieBotState');
    }
  }

  calcVh() {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  }

  iosFullscreenChange(state) {
    this.scrollY = window.scrollY || window.pageYOffset || +localStorage.getItem('positionY');
    localStorage.setItem('positionY', this.scrollY.toString());
    if (state) {
      this.scrollY = window.scrollY;
    }
    else {
      setTimeout( () => {
        window.scrollTo({
          top: +localStorage.getItem('positionY'),
          behavior: 'instant',
        } as any);
        localStorage.removeItem('positionY');
      });
    }
    this.iosFullscreen = state;
  }

  destroyed() {
    window.removeEventListener('resize', this.calcVh);
    bus.$off(EventEmitter.Events.IOS_FULLSCREEN_CHANGE, this.iosFullscreenChange);
  }
}
